import { PromoteRelocationDialog } from "@/app/Promotions/Components/PromoteRelocationDialog";
import { PromotionChannelTable } from "@/app/Promotions/Components/PromotionChannelTable";
import { useRelocationRecord } from "@/app/Relocations/Hooks/useRelocationRecord";
import { Button } from "@/components/catalyst/button";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { PlusIcon } from "@heroicons/react/20/solid";
import { useTranslations } from "use-intl";

export function RelocationAdsScreen() {
  const relocation = useRelocationRecord();
  const { open: openPromoteDialog } = useDialog(PromoteRelocationDialog);
  const t = useTranslations("promotion.ads");

  return (
    <div className="py-6">
      <RecordScreenCard title={t("title")}>
        <PromotionChannelTable
          id="relocation-ads"
          relocationId={relocation.id}
          rightButtons={
            <Button
              LeadingIcon={PlusIcon}
              onClick={() => {
                openPromoteDialog({ relocationId: relocation.id });
              }}
            >
              {t("createAd")}
            </Button>
          }
        />
      </RecordScreenCard>
    </div>
  );
}
